// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1580":"696ceaa2","1677":"68b2b4b7"}[chunkId] + ".chunk.css";
};